/**
 * Autocomplete enum for HTML input elements.
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete
 */

export enum AutoComplete {
  OFF = 'off',
  FIRST_NAME = 'given-name',
  LAST_NAME = 'family-name',
  EMAIL = 'email',
  PHONE_DIALLING_CODE = 'tel-country-code',
  PHONE_NUMBER = 'tel-national',
}
